import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { LanguageCode } from "./Language";
import { DeviceConnection } from "./networking/DeviceConnection";
import { SupportedDevices } from "./networking/NetTypes";


export const DeviceConnectionCTX = createContext<DeviceConnection<SupportedDevices> | undefined>(undefined);
export function useDeviceConnection() {
	const context = useContext(DeviceConnectionCTX);
	if (undefined === context) throw "Missing mqtt context.";
	return context;
}


export const DeviceAlarmCTX = createContext<{
	showAlarm: boolean,
	setShowAlarm: Dispatch<SetStateAction<boolean>>,
} | null>(null);

export const RefreshContext = createContext(5);


export const Language = createContext<LanguageCode>("cs");


